export default "__VITE_ASSET__CCXPNvqX__"